import { render, staticRenderFns } from "./MainShow.vue?vue&type=template&id=2093b66a&scoped=true"
import script from "./MainShow.vue?vue&type=script&lang=js"
export * from "./MainShow.vue?vue&type=script&lang=js"
import style0 from "./MainShow.vue?vue&type=style&index=0&id=2093b66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2093b66a",
  null
  
)

export default component.exports